<template>
    <div class="flex justify-center mt-[-80px] sm:mt-0" >
      <video
        class="sm:h-44 lg:rounded-2xl md:rounded-2xl" 
        autoplay
        muted
        playsinline
        loop
      >
        <source src="../assets/ruta-avion.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </template>
  
  <script>
  export default {
    name: 'VideoTam'
  }
  </script>